import React, { ComponentPropsWithoutRef } from 'react';

import { OneInchNetwork, OneInchToken } from '@api';

import Spinner from '@uikit/components/Spinner/Spinner';
import { Amount } from '@uikit/icons/Amount';
import { AngleUp } from '@uikit/icons/AngleUp';

import { TokenOption } from '@magic-swap/components/pages/MagicSwap/ui/TokenOption';

interface TokenSelectButtonProps extends ComponentPropsWithoutRef<'button'> {
  network?: OneInchNetwork;
  token?: OneInchToken;
  tokens: OneInchToken[];
  setToken: (token: OneInchToken) => void;
  isLoading?: boolean;
  fetchTokenBalance: () => Promise<void>;
}

export const TokenSelectButton = ({
  network,
  token,
  tokens,
  setToken,
  isLoading,
  fetchTokenBalance,
  disabled,
  ...props
}: TokenSelectButtonProps) => {
  return (
    <button
      className="flex items-center t-h4 max-sm:text-[14px] text-left focus-visible:outline-none py-2 pr-2 bg-transparent rounded-2xl text-[24px] text-neutral-500 w-fit overflow-auto"
      disabled={!network || isLoading || !tokens?.length || disabled}
      {...props}
    >
      {isLoading && <Spinner size="sm" color="primary" />}
      {!isLoading && !token && <Amount className="icon text-secondary" />}
      {!isLoading && token ? (
        <TokenOption token={token} selectedView className="w-fit" />
      ) : (
        <p className="ml-2">Select a Token</p>
      )}

      <AngleUp className="icon rotate-90 text-primary" />
    </button>
  );
};
